import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  content: {
    flexGrow: 1,
  },
  card: {
    padding: '10px 0',
    background: 'none',
    borderRadius: '16px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  },
  heading: {
    padding: '0 15px 0 16px',
    fontWeight: 700,
    fontSize: 25,
    color: '#58595B',
    margin: '0 0 10px 0',
    alignItems: 'center'
  },
  wrapper: {
    margin: 20,
    overflowX: 'auto',
    '&>*': {
      overflowX: 'auto',
    },
  },
  formContainer: {
    marginLeft: '2%', 
    marginRight: '2%', 
    display: 'flex', 
    flexDirection: 'column'
  },
  formInputsContainer: {
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop: '8px'
  },
  innerBoxContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    marginBottom: '10px',
    paddingBottom: '20px',
    paddingTop: '10px',
    display: 'flex',
    flexDirection: 'column'
  },
  iconStyle: {
    color: '#32A2B9'
  },
  TextIconContainer: {
    display: 'flex', 
    alignItems: 'center',
    cursor: 'pointer',
    color: '#666',
    fontSize: 14,
  },
  divider: {
    borderBottom: '1px solid black',
    margin: '10px 0 0 10px',
  },
  innerValue: {
    marginLeft: '5%',
    color: '#9D9999',
    marginTop: '1%',
    marginBottom: '1%'
  },
  textTitleStyle: {
    fontWeight: 501,
    fontSize: 14,
    color: '#666',
    marginRight: '5px'
  },
  textStyle: {
    color: '#534D4D',
    fontSize: 14,
  },
  titleOutside: {
    fontWeight: 'bold',
    marginTop: '0px', 
    marginBottom: '20px',
    paddingBottom: '5px',
    fontSize: '1.1rem',
    borderBottom: '1px solid #eeeeee',
  },
  titleInside: {
    color: 'black', 
    paddingTop: '15px', 
    paddingBottom: '20px'
  },
  listIndicator: {
    display: 'list-item', 
    listStyleType: 'disc',
    paddingLeft: '25px'
  },
  unorderListContainer: {
    listStyleType: 'none', 
    margin: '10px', 
    paddingLeft: '10px'
  },
  listContainer: {
    position: 'relative',
    color: '#534D4D',
    fontSize: 14,
  },
  insideTextBold: {
    fontSize: 14,
    paddingRight: '5px'
  },
  loading: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default useStyles;
